module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-09-489430e4f630863240e621c846568afb.jpg";